var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"site-page"},[_c('intro'),_c('about'),_c('shops')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }